var map = {
	"./buque-ap.png": 871,
	"./buque-dd-ap.png": 872,
	"./buque-dd.png": 873,
	"./buque-di-ap.png": 874,
	"./buque-di.png": 875,
	"./buque.png": 876,
	"./buqueCargador-ap.png": 877,
	"./buqueCargador-dd-ap.png": 878,
	"./buqueCargador-dd.png": 879,
	"./buqueCargador-di-ap.png": 880,
	"./buqueCargador-di.png": 881,
	"./buqueCargador.png": 882,
	"./buqueCargadorDerecha-ap.png": 883,
	"./buqueCargadorDerecha-dd-ap.png": 884,
	"./buqueCargadorDerecha-dd.png": 885,
	"./buqueCargadorDerecha-di-ap.png": 886,
	"./buqueCargadorDerecha-di.png": 887,
	"./buqueCargadorDerecha.png": 888,
	"./buqueDerecha-ap.png": 889,
	"./buqueDerecha-dd-ap.png": 890,
	"./buqueDerecha-dd.png": 891,
	"./buqueDerecha-di-ap.png": 892,
	"./buqueDerecha-di.png": 893,
	"./buqueDerecha.png": 894,
	"./buqueIzquierda-ap.png": 895,
	"./buqueIzquierda-dd-ap.png": 896,
	"./buqueIzquierda-dd.png": 897,
	"./buqueIzquierda-di-ap.png": 898,
	"./buqueIzquierda-di.png": 899,
	"./buqueIzquierda.png": 900,
	"./buqueIzquierdaCargador-ap.png": 901,
	"./buqueIzquierdaCargador-dd-ap.png": 902,
	"./buqueIzquierdaCargador-dd.png": 903,
	"./buqueIzquierdaCargador-di-ap.png": 904,
	"./buqueIzquierdaCargador-di.png": 905,
	"./buqueIzquierdaCargador.png": 906,
	"./buqueIzquierdaCargadorDerecha-ap.png": 907,
	"./buqueIzquierdaCargadorDerecha-dd-ap.png": 908,
	"./buqueIzquierdaCargadorDerecha-dd.png": 909,
	"./buqueIzquierdaCargadorDerecha-di-ap.png": 910,
	"./buqueIzquierdaCargadorDerecha-di.png": 911,
	"./buqueIzquierdaCargadorDerecha.png": 912,
	"./buqueIzquierdaDerecha-ap.png": 913,
	"./buqueIzquierdaDerecha-dd-ap.png": 914,
	"./buqueIzquierdaDerecha-dd.png": 915,
	"./buqueIzquierdaDerecha-di-ap.png": 916,
	"./buqueIzquierdaDerecha-di.png": 917,
	"./buqueIzquierdaDerecha.png": 918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;